import { cloneDeep, set } from 'lodash';
import uuid from 'uuid';
import {
  Contact,
  ContactTypeRole,
  MechanicCertification,
  SPPContactTypeLevels,
  SPPContactTypeRoleAreas,
  SPPContactTypeServices,
} from '../../../Types';
import { hasContactTypeRoleLevel } from '../Utils';

const addCertificate = (contact: Contact, certificate: MechanicCertification | undefined): Contact => {
  const newContact = cloneDeep(contact);
  if (!certificate) return newContact;
  set(newContact, 'certifications', [...newContact.certifications || [], certificate]);
  return newContact;
};

const addContactTypeRoleArea = (
  {
    contact, service, roleArea, level, location,
  }: {
    contact: Contact,
    service: SPPContactTypeServices,
    roleArea: SPPContactTypeRoleAreas,
    level: SPPContactTypeLevels,
    location: string,
  },
): Contact => {
  const newContact = cloneDeep(contact);
  if (!hasContactTypeRoleLevel({
    data: contact,
    services: [service],
    roleAreas: [roleArea],
    levels: [level],
  })) {
    // newContact TypeRole Area
    const newRoleArea: ContactTypeRole = {
      role_area: roleArea,
      levels: [{
        location: `10~${location.split('10~').pop()}`,
        level,
      }],
    };

    const contactTypes = cloneDeep(contact.contact_types) || [];

    if (contactTypes.some((ct) => ct.service === service)) {
      for (let i = 0; i < contactTypes?.length; i++) {
        if (contactTypes[i].service === service) {
          contactTypes[i].role_areas.push(newRoleArea);
        }
      }
    } else {
      contactTypes.push(
        {
          service,
          role_areas: [newRoleArea],
          id: uuid.v4(),
        },
      );
    }
    set(newContact, 'contact_types', contactTypes);
  }

  return newContact;
};

export {
  addCertificate,
  addContactTypeRoleArea,
};
